export class BusinessVpvEventDto {
    event: string;
    event_params: BusinessEventParamsDto;
    user_properties?: BusinessUserPropertiesDto;
}

export class BusinessUserPropertiesDto {
    pas_dni_hashed: string;
    birthday?: string;
    user_type: string;
}

export class BusinessEventParamsDto {
    micrositio: string;
    page_path: string;
    page_type: string;
    page_title: string;            
    homemarket: string;
    environment: string;
    login: boolean;
}